import { Box, Button, Paper, SxProps, Theme } from "@mui/material";
import { AbstractTypedDataForm } from "../../components/data/DataForm";
import { FormNumberInput, TextInput } from "../../components/form/TextInput";
import { isOwner } from "../../models/Identity";
import { Payment } from "../../models/Types";
import { isMobile } from "../../utils";
import BillCombo, { billStore } from "../bill/BillCombo";
import HouseCombo from "../houses/HouseCombo";
import InhabitantCombo from "../inhabitants/InhabitantCombo";

export function paymentParse(d?: any) {
    const dto = (d || {}) as Payment;
    d?.CreateDate && (dto.CreateDate = new Date(d.CreateDate));
    return dto;
}

export default class PaymentForm extends AbstractTypedDataForm<Payment, { billId?: number }, { billId?: number }> {
    protected getTypeId(): string { return 'Payment'; }
    protected getTypeName(): React.ReactNode { return 'Платеж'; }

    constructor(p) {
        super(p);

        this.state = { ...this.state, billId: p.billId };
    }

    createEntity() {
        const entity = super.createEntity();
        if (this.state.billId) {
            entity.BillId = this.state.billId;
        }

        return entity;
    }

    componentDidMount() {
        super.componentDidMount();

        if (this.props.billId) {

        }
    }

    buildButtons() {
        return [];
    }

    protected getFormStyle(): SxProps<Theme> | undefined {
        if (isMobile()) {
            return {
                ...super.getFormStyle(),
                flexDirection: 'column',
                alignItems: 'stretch',
                p: 2
            };
        } else {
            return super.getFormStyle();
        }
    }

    protected onFieldChange(field: string, value: any) {
        if (field === 'BillId') {
            if (value /** && !(this.state.entity as any).Sum /**/) {
                super.onFieldChange('Sum', billStore.data?.find(b => b.Id === value)?.Obj?.Amount);
            }
        }

        if (field === 'BillId' || field === 'HouseId') {
            this.forceUpdate();
        }

        return super.onFieldChange(field, value);
    }

    protected buildItems(entity?: Payment | undefined): React.ReactNode {
        const ism = isMobile();
        const disabled = this.isReadOnly() || ism;

        const items = <>
            <TextInput
                required={true}
                value={entity?.HouseId}
                label="Домвладение"
                name="HouseId"
                onChange={this.onChange}
                component={(onChange, error) => <HouseCombo
                    name="HouseId"
                    error={!!error}
                    disabled={disabled}
                    selectFirstOnLoad={entity && !isOwner() && !entity.Id}
                    value={entity?.HouseId}
                    onChange={onChange} />} />

            <TextInput
                value={entity?.PayerId}
                label="Плательщик"
                name="PayerId"
                onChange={this.onChange}
                component={(onChange, error) => <InhabitantCombo
                    name="PayerId"
                    error={!!error}
                    disabled={disabled}
                    selectFirstOnLoad={entity && !isOwner() && !entity.Id}
                    value={entity?.PayerId}
                    onChange={onChange} />} />

            <TextInput key={'BillId' + entity?.HouseId}
                value={entity?.BillId}
                label="Начисление"
                name="BillId"
                onChange={this.onChange}
                component={(onChange, error) => <BillCombo
                    name="BillId"
                    error={!!error}
                    disabled={disabled}
                    selectFirstOnLoad={entity && !entity.Id && !entity.BillId}
                    filter={x => !entity?.HouseId || (x.Obj?.HouseId === entity.HouseId)}
                    onDataLoad={vs => {
                        if (this.props.billId && (this.props.billId === entity?.BillId)) {
                            let bill = vs?.find(x => x.Id === this.props.billId);
                            if (bill) {
                                this.onFieldChange('HouseId', bill.Obj.HouseId);
                                this.onFieldChange('BillId', this.props.billId);
                            }
                        }
                    }}
                    value={entity?.BillId}
                    onChange={onChange} />} />

            <FormNumberInput key={'sum' + entity?.BillId + entity?.HouseId} label="Сумма" name="Sum" inputProps={{ disabled }} form={this} entity={entity} />
        </>;

        if (ism) {
            return items;
        }

        return <Paper sx={{ minWidth: 500 }} style={{ overflow: 'auto' }}>
            {items}
            {disabled ? null : <>
                <div style={{ flex: 1 }} />

                <Box sx={{ display: 'flex' }}>
                    <div style={{ flex: 1 }} />
                    {<Button variant="contained" type="submit">Сохранить</Button>}
                </Box>
            </>}
        </Paper>;
    }
}